import { useAppSelector } from 'hooks/reduxHooks';
import { get } from 'lodash-es';

type ErrorState = {
  message: string;
  value: boolean;
};

interface IPageErrorState {
  error401: ErrorState;
  error404: ErrorState;
}

/**
 * Information about whether there is a page error.
 *
 * @returns error401
 * @returns error404
 */
const usePageErrorState = (): IPageErrorState => {
  const has404Error = useAppSelector((state) =>
    get(state, 'main.pageError', false),
  );
  const error401 = useAppSelector((state) =>
    get(state, 'state.main.pageErrors.error401', { value: false, message: '' }),
  );
  return {
    error401,
    error404: {
      message: '',
      value: has404Error,
    },
  };
};

export default usePageErrorState;
